import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import PublicNav from "@/components/PublicNav";
import PublicFooter from "@/components/PublicFooter";
import usePageMeta from "@/hooks/usePageMeta";

export default function BlogDetail() {
  const { slug } = useParams();
  const [b, setB] = useState(null);
  useEffect(() => { api.get(`/blogs/${slug}`).then((r) => setB(r.data)).catch(() => setB(false)); }, [slug]);
  usePageMeta(
    b && b !== false ? (b.seo_title || `${b.title} — Blog`) : "Blog",
    b && b !== false ? (b.meta_description || (b.content || "").replace(/<[^>]+>/g, "").slice(0, 160)) : "",
  );

  if (b === null) return <div className="min-h-screen bg-white"><PublicNav /><div className="p-10 text-slate-500">Loading…</div></div>;
  if (b === false) return <div className="min-h-screen bg-white"><PublicNav /><div className="p-10 text-slate-500">Not found. <Link to="/blogs" className="text-blue-700 underline">← Back</Link></div></div>;

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <PublicNav />
      <article className="mx-auto max-w-3xl px-6 py-12 flex-1 w-full">
        <div className="text-xs uppercase tracking-[0.2em] font-semibold text-amber-600 mb-3">{(b.tags || []).join(" · ")}</div>
        <h1 className="text-4xl md:text-5xl font-black tracking-tight text-slate-900 break-words" data-testid="blog-title">{b.title}</h1>
        <div className="text-sm text-slate-500 mt-3">By {b.author}</div>
        {b.cover_image && (
          <img
            src={b.cover_image}
            alt=""
            onError={(e) => { e.currentTarget.style.display = "none"; }}
            className="w-full aspect-[16/9] object-cover rounded mt-8"
          />
        )}
        <div
          className="prose prose-slate max-w-none mt-8 text-slate-700 leading-relaxed break-words
                     [word-break:break-word] [overflow-wrap:anywhere]
                     prose-headings:text-slate-900 prose-p:my-4 prose-a:text-blue-700
                     prose-img:rounded prose-img:my-6"
          dangerouslySetInnerHTML={{ __html: b.content }}
        />
      </article>
      <PublicFooter />
    </div>
  );
}
